import { useContext } from 'react'

import { HasuraContext } from '../internal/context'
import type { HasuraContextType } from '../internal/types'

export default function useHasuraContext(): HasuraContextType | null {
  return useContext(HasuraContext)
}
